import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import StatusMessages from '../../components/StatusMessages';
import simpleReactValidator from 'simple-react-validator';

import { forgotPassword } from '../../actions/user';

class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.validator = new simpleReactValidator();
    this.state = {
      username: '',
      reset_password_loading: false,
      has_errors: false
    };

    this.onChange = this.onChange.bind(this);
  }

  onChange = e => {
    e.preventDefault();

    const { name, value } = e.target;

    this.setState({
      [name]: value
    });
  };

  handleSubmit = e => {
    e.preventDefault();

    const { username } = this.state;
    if (this.validator.allValid()) {
      this.validator.hideMessages();
      this.props.forgotPassword(username);
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  render() {
    const { username, has_errors } = this.state;
    const { user } = this.props;

    return (
      <div className="clearfix">
        {user.errorResetPassword ? (
          <StatusMessages
            type="error"
            message={
              user.errorMessageResetPassword +
              ' Please make sure the Username you supplied is correct'
            }
          />
        ) : null}
        {user.success ? (
          <StatusMessages type="success" message={user.successMessage} />
        ) : null}
        <form name="resetpwdfrm" onSubmit={this.handleSubmit}>
          <input
            name="username"
            className="form-control"
            label="Username"
            placeholder="Username"
            type="text"
            value={username}
            onChange={this.onChange}
          />
          {this.validator.message(
            'username',
            username,
            'required',
            'text-danger'
          )}
          <div className="form-group">
            <button type="submit" className="btn btn-warning">
              Reset Password
            </button>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.user
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ forgotPassword }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResetPassword);



// WEBPACK FOOTER //
// ./src/pages/auth/ResetPassword.js